"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Person = void 0;
const DefaultContactDetails_1 = require("./commonAttributeSets/DefaultContactDetails");
const ModelCommon_1 = require("./ModelCommon");
const typeName = 'Person';
class Person extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        super(ob?.type ?? typeName, ob);
        this.title = ob?.title;
        this.name = ob?.name;
        this.firstName = ob?.firstName ?? ob?.first_name;
        delete this.first_name;
        this.lastName = ob?.lastName ?? ob?.last_name;
        delete this.last_name;
        if (this.firstName && this.lastName)
            this.name = this.firstName + ' ' + this.lastName;
        this.email = ob?.email;
        this.dwelling_number = ob?.dwelling_number;
        this.street_number = ob?.street_number;
        this.suburb = ob?.suburb;
        this.city = ob?.city;
        this.country = ob?.country;
        this.post_code = ob?.post_code;
        this.phoneNumber = ob?.phoneNumber ?? ob?.phone_number;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            firstName: {
                type: 'String',
                editable: true,
                //displayFn: () => this.firstName ?? this.first_name,
            },
            lastName: {
                type: 'String',
                editable: true,
                //displayFn: () => this.lastName ?? this.last_name,
            },
            // date_of_birth: {
            //   type: 'Date',
            //   precision: UserAttributeKeyDatePrecision.Date,
            //   editable: true,
            // },
            ...DefaultContactDetails_1.DefaultContactDetails,
        };
    }
}
exports.Person = Person;
